import Activity from "@/components/Activity";
import MatchingLayout from "@/components/matching/Layout";
import MatchingIndex from "@/components/matching/Index";
import MatchingGroups from "@/components/matching/Groups";
import MatchingClasses from "@/components/matching/Classes";
import MatchingUsers from "@/components/matching/Users";
import Classroom from "@/components/classroom/Index";
import ClassroomLayout from "@/components/classroom/Layout";
import Class from "@/components/classroom/Class";
import Guardian from "@/components/guardian/Guardian";
import OrganisationSchools from "@/components/organisation/google/Schools";
import OrganisationSettings from "@/components/organisation/google/Settings";
import Calendar from "@/components/calendar/Index";
import Classrooms from "@/components/classrooms/Index";
import ClassroomsLayout from "@/components/classrooms/Layout";

export default [
	{
		path: "/matching",
		component: MatchingLayout,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: true
		},
		children: [
			{
				name: "matching",
				path: "",
				component: MatchingIndex,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: true
				}
			},
			{
				name: "matching.groups",
				path: "/matching/groups",
				component: MatchingGroups,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: true
				}
			},
			{
				name: "matching.classes",
				path: "/matching/classes",
				component: MatchingClasses,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: true
				}
			},
			{
				name: "matching.users",
				path: "/matching/users",
				component: MatchingUsers,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: true
				}
			}
		]
	},
	{
		name: "activity",
		path: "/activity",
		component: Activity,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: true
		}
	},
	{
		name: "guardian",
		path: "/guardian",
		component: Guardian,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: true
		}
	},
	{
		name:"classrooms.layout",
		path: "/classrooms",
		component: ClassroomLayout,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: false
		},
		children: [
			{
				name: "classrooms",
				path: "/classrooms",
				component: Classroom,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: false
				},
				children: [
					{
						name: "classrooms.select",
						path: "/classrooms/:id",
						component: Class,
						meta: {
							requiresAuth: true,
							requiresShard: true,
							completedWizard: false
						}
					}
				]
			}
		]
	},
	/** Temporary URL for new classrooom management page */
	{
		name:"classrooms2.layout",
		path: "/classrooms2",
		component: ClassroomsLayout,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: false
		},
		children: [
			{
				name: "classrooms2",
				path: "/classrooms2",
				component: Classrooms,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: false
				}
			}
		]
	},
	{
		name: "organisation.schools",
		path: "/organisation/schools",
		component: OrganisationSchools,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: false
		}
	},
	{
		name: "organisation.settings",
		path: "/organisation/settings",
		component: OrganisationSettings,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: false,
			requiresEnterprise: true
		}
	},
	{
		name: "calendar",
		path: "/calendar",
		component: Calendar,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: true
		}
	},
];
